<template>
  <div class="bg-black flex-col relative w-full h-full flex items-center">
    <img class="video" ref="start" />
    <slot></slot>
  </div>
</template>

<script>
import CacheManager from '@/modules/cache-manager';

export default {
  name: 'VideoBackground',
  props: {
    type: String,
  },
  async mounted() {
    this.handler = null;
    this.playVideo();
  },
  beforeDestroy() {
    if (this.handler) {
      console.log('stop wait video');
      clearTimeout(this.handler);
      this.handler = null;
    }
  },
  methods: {
    async playVideo() {
      const [startSrc, loopSrc] = await Promise.all([
        CacheManager.getGifSrc(this.startKey),
        CacheManager.getGifSrc(this.loopKey),
      ]);
      if (!this.$refs.start) return;
      this.$refs.start.src = startSrc;
      this.handler = setTimeout(async () => {
        this.$refs.start.src = loopSrc;
      }, this.duration);
    },
  },
  computed: {
    startKey() {
      return this.type === 'foot' ? 'footStart' : 'start';
    },
    loopKey() {
      return this.type === 'foot' ? 'footLoop' : 'loop';
    },
    duration() {
      return this.type === 'foot' ? 33000 : 30200;
    },
  },
};
</script>

<style lang="scss" scoped>
.video {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  background: #000;
  background-size: cover;
  object-fit: scale-down;
  pointer-events: none;
}
</style>
